/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  PriceRequest,
  PriceResponse
} from './data.schemas'




export const getPrices = (
    segmentationId: number,
    priceRequest: PriceRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PriceResponse[]>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/price`,
      priceRequest,options
    );
  }



export const getGetPricesMutationOptions = <TError = AxiosError<string[] | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPrices>>, TError,{segmentationId: number;data: PriceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getPrices>>, TError,{segmentationId: number;data: PriceRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPrices>>, {segmentationId: number;data: PriceRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  getPrices(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetPricesMutationResult = NonNullable<Awaited<ReturnType<typeof getPrices>>>
    export type GetPricesMutationBody = PriceRequest
    export type GetPricesMutationError = AxiosError<string[] | void>

    export const useGetPrices = <TError = AxiosError<string[] | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPrices>>, TError,{segmentationId: number;data: PriceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof getPrices>>,
        TError,
        {segmentationId: number;data: PriceRequest},
        TContext
      > => {

      const mutationOptions = getGetPricesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    